import { fork, take, call, put, select } from "redux-saga/effects";

import { apiGet } from './callApi';
import { transformNextInstanceTemplate } from "./helpers/transform";

import actionTypes from "../actionTypes";
import {
  failCasinoTournamentNextInstance,
  successCasinoTournamentNextInstance
} from "../actionCreators/gameBoxMission";
import { getSkinId, getToken, getTournamentGameBoxMission } from "../selectors";

import apiRoutes from "../../constants/apiRoutes";


function* getNextInstanceTemplate(): any {
  const tournamentMission = yield select(getTournamentGameBoxMission);
  const skinId = yield select(getSkinId);

  if (tournamentMission) {
    try {
      const headers = {};
      const token = yield select(getToken);
      headers['x-access-token'] = JSON.stringify(token);
      let params: any = {
        skinId: skinId,
        templateId: tournamentMission.prize.templateId,
        token: token
      };
      let response;
      if (tournamentMission.status === 'completed' && tournamentMission.prize?.tourInstanceId) {
        params.tourInstanceId = tournamentMission.prize.tourInstanceId;
        response = yield call(apiGet, 'REACT_APP_API_URL', apiRoutes.GET_CASINO_TOURNAMENT_INSTANCES, params, headers);
        response.data.result = response.data.result[0];
      } else {
        response = yield call(apiGet, 'REACT_APP_API_URL', apiRoutes.GET_CASINO_TOURNAMENT_NEXT_INSTANCE, params, headers);
      }
      if (response?.data?.result) {
        const transformData = transformNextInstanceTemplate(response.data.result);
        yield put(successCasinoTournamentNextInstance(transformData));
      } else {
        yield put(failCasinoTournamentNextInstance());
      }
    } catch (error) {
      yield put(failCasinoTournamentNextInstance(error));
    }
  }
}

export default function* watchGameBoxNextInstanceTemplateRequest() {
  while (true) {
    yield take([
      actionTypes.GAME_BOX_MISSION_SUCCESS,
      actionTypes.CASINO_TOURNAMENT_NEXT_INSTANCE_REQUEST
    ]);

    yield fork(getNextInstanceTemplate);
  }
}
